import React from 'react';
import { makeStyles } from 'tss-react/mui';
const useStyles = makeStyles()((theme, { height = 60 }) => ({
    container: {
        height,
        display: "flex",
        borderRadius: 14,
        alignItems: "center",
        padding: "0 12px",
        border: `1px solid ${theme.palette.iisightGray200}66`,
        backgroundColor: theme.palette.iisightWhiteBackground,
    },
}));
export const Container = ({ children, height }) => {
    const { classes } = useStyles({ height });
    return React.createElement("div", { className: classes.container }, children);
};
